import {
  FETCH_STOCK_ISSUES_REQUEST,
  FETCH_STOCK_ISSUES_SUCCESS,
  FETCH_STOCK_ISSUES_FAILURE,
  CREATE_STOCK_ISSUE_SUCCESS,
  MARK_STOCK_ISSUE_RECEIVED_SUCCESS,
  DELETE_STOCK_ISSUE_SUCCESS,
  FETCH_STOCK_ISSUES_BY_EMPLOYEE_SUCCESS,
  FETCH_STOCK_ISSUES_BY_BATCH_SUCCESS,
  FETCH_UNIQUE_EMPLOYEES_SUCCESS,
  FETCH_UNIQUE_BATCHES_SUCCESS,
  FETCH_STOCK_RECEIVED_REPORT_REQUEST,
  FETCH_STOCK_RECEIVED_REPORT_SUCCESS,
  FETCH_STOCK_RECEIVED_REPORT_FAILURE
} from '../../types/stockIssue/stockIssueTypes';

const initialState = {
  stockIssues: [],
  filteredStockIssues: [],
  uniqueEmployees: [],
  uniqueBatches: [],
  stockReceivedReport: {
    rows: [],
    totals: {}
  },
  loading: false,
  appending: false,
  error: null
};

const stockIssueReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STOCK_ISSUES_REQUEST:
      return { 
        ...state, 
        loading: action.append ? state.loading : true, 
        appending: Boolean(action.append),
        error: null 
      };
    case FETCH_STOCK_ISSUES_SUCCESS:
      if (action.append) {
        const existingIds = new Set(state.stockIssues.map(issue => issue.id));
        const merged = [
          ...state.stockIssues,
          ...action.payload.filter(issue => !existingIds.has(issue.id)),
        ];
        return { 
          ...state, 
          loading: false, 
          appending: false, 
          stockIssues: merged, 
          filteredStockIssues: merged 
        };
      }
      return { ...state, loading: false, appending: false, stockIssues: action.payload, filteredStockIssues: action.payload };
    case FETCH_STOCK_ISSUES_FAILURE:
      return { ...state, loading: false, appending: false, error: action.payload };
    case FETCH_STOCK_ISSUES_BY_EMPLOYEE_SUCCESS:
      return { ...state, loading: false, filteredStockIssues: action.payload };
    case FETCH_STOCK_ISSUES_BY_BATCH_SUCCESS:
      return { ...state, loading: false, filteredStockIssues: action.payload };
    case FETCH_UNIQUE_EMPLOYEES_SUCCESS:
      return { ...state, uniqueEmployees: action.payload };
    case FETCH_UNIQUE_BATCHES_SUCCESS:
      return { ...state, uniqueBatches: action.payload };
    case CREATE_STOCK_ISSUE_SUCCESS:
      return { ...state, stockIssues: [...state.stockIssues, action.payload] };
    case MARK_STOCK_ISSUE_RECEIVED_SUCCESS:
      return {
        ...state,
        stockIssues: state.stockIssues.map(issue =>
          issue.id === action.payload.id ? { ...issue, ...action.payload } : issue
        ),
        filteredStockIssues: state.filteredStockIssues.map(issue =>
          issue.id === action.payload.id ? { ...issue, ...action.payload } : issue
        )
      };
    case DELETE_STOCK_ISSUE_SUCCESS:
      return {
        ...state,
        stockIssues: state.stockIssues.filter(issue => issue.id !== action.payload),
        filteredStockIssues: state.filteredStockIssues.filter(issue => issue.id !== action.payload)
      };
    case FETCH_STOCK_RECEIVED_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_STOCK_RECEIVED_REPORT_SUCCESS:
      return { ...state, loading: false, stockReceivedReport: action.payload };
    case FETCH_STOCK_RECEIVED_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default stockIssueReducer; 